import { render } from "./FileSearch.vue?vue&type=template&id=c05216a6&scoped=true"
import script from "./FileSearch.vue?vue&type=script&lang=js"
export * from "./FileSearch.vue?vue&type=script&lang=js"

import "./FileSearch.vue?vue&type=style&index=0&id=c05216a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05216a6"]])

export default __exports__